





























































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SectionVerHidup extends Vue {
  @Prop() form!: any;

  get gcsTotal() {
    const e = this.form.gcs_e || 0;
    const v = this.form.gcs_v || 0;
    const m = this.form.gcs_m || 0;
    return e + v + m || "-";
  }

  regioList = [
    { field: "pf_anggota_gerak_atas_kanan", label: "Anggota Gerak Atas Kanan", hint: "Lengan atas, lengan bawah, tangan kanan. Deskripsikan luka, memar, edema, deformitas..." },
    { field: "pf_anggota_gerak_atas_kiri", label: "Anggota Gerak Atas Kiri", hint: "Lengan atas, lengan bawah, tangan kiri. Deskripsikan luka, memar, edema, deformitas..." },
    { field: "pf_kepala", label: "Kepala", hint: "Rambut, kulit kepala, bentuk tengkorak. Deskripsikan luka, hematom, benjolan..." },
    { field: "pf_leher", label: "Leher", hint: "Jejas, bekas cekikan, nyeri tekan, deformitas..." },
    { field: "pf_dada", label: "Dada", hint: "Bentuk, simetris, jejas, krepitasi, nyeri tekan..." },
    { field: "pf_punggung", label: "Punggung", hint: "Jejas, luka, nyeri tekan, deformitas tulang belakang..." },
    { field: "pf_perut", label: "Perut", hint: "Datar/cembung, nyeri tekan, defense muscular, jejas..." },
    { field: "pf_pinggang", label: "Pinggang", hint: "Jejas, nyeri ketok CVA, deformitas..." },
    { field: "pf_pantat", label: "Pantat", hint: "Jejas, luka, memar..." },
    { field: "pf_dubur", label: "Dubur / Anus", hint: "Robekan, luka, perdarahan..." },
    { field: "pf_alat_kelamin", label: "Alat Kelamin", hint: "Luka, robekan, perdarahan, tanda kekerasan seksual..." },
    { field: "pf_anggota_gerak_bawah_kanan", label: "Anggota Gerak Bawah Kanan", hint: "Paha, tungkai bawah, kaki kanan. Deskripsikan luka, memar, edema, deformitas..." },
    { field: "pf_anggota_gerak_bawah_kiri", label: "Anggota Gerak Bawah Kiri", hint: "Paha, tungkai bawah, kaki kiri. Deskripsikan luka, memar, edema, deformitas..." },
  ];
}
